(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["reviews"]) return;
  try {
    

var requestOptions = {
  header: {
    'Content-Type': 'application/x-www-form-urlencoded',
  },
  method: 'GET'
};

fetch("http://stamped.io/api/widget/reviews?isWithPhotos&take=3&storeUrl=103569&apiKey=pubkey-1W01YekPtU0kCf65p72yNtV5xoKxR7&type&minRating=4&sortReviews=featured", requestOptions).then(res => res.json()).then(data => {
    console.log(data)
  let reviews = data.data;
  for (let i = 0; i < reviews.length; i++) {
    let starCount = reviews[i].reviewRating
    let rating = '';
    for (let i = 0; i < 5; i++) {
        rating += `<svg class="icon-star" xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M6.25379 0.481803L4.55192 4.11713L0.70307 4.69112C0.0223208 4.80046 -0.239506 5.67512 0.257965 6.19445L3.00714 9.00978L2.35258 12.9731C2.24785 13.6838 2.98096 14.2304 3.58316 13.9024L7.01309 12.0164L10.4168 13.9024C11.019 14.2304 11.7522 13.6838 11.6474 12.9731L10.9929 9.00978L13.742 6.19445C14.2395 5.67512 13.9777 4.80046 13.2969 4.69112L9.47426 4.11713L7.74621 0.481803C7.4582 -0.146862 6.56799 -0.174195 6.25379 0.481803Z" fill="${i < starCount ? '#F9D248':'#eee'}"/></svg>`
    }
    
    document.querySelector('.reviews-section ul').insertAdjacentHTML('beforeend',`
     <li>
      <img class="main-img" src="${reviews[i].productImageLargeUrl}" alt="image">
      <p class="name">${reviews[i].author}</p>
      <p class="state">${reviews[i].location}</p>
      <div class="d-flex">${rating}</div>
      <p class="text">${reviews[i].reviewMessage}</p>
      <a href="${reviews[i].productUrl}" class="d-flex items-center">
        <img class="small-img" src="${reviews[i].productImageThumbnailUrl}" alt="image">
        <span class="c-gray">${reviews[i].productName}</span>
      </a>
    </li>`)
  }
}).catch((error) => {
    console.error('Error:', error);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["why-buy"]) return;
  try {
    
  if (window.matchMedia('(max-width: 768px)')) {
    document.querySelectorAll('.why-buy .list-current').forEach(item => {
        item.addEventListener('click', (e) => {
            console.log(e.target)
            item.parentElement.classList.toggle('active');
            item.nextElementSibling.classList.toggle('d-none');
        })
    })
  }

  } catch(e) { console.error(e); }
})();
})();
